import { render } from "./block-ip-addresses.vue?vue&type=template&id=5a1f0a35"
import script from "./block-ip-addresses.vue?vue&type=script&lang=js"
export * from "./block-ip-addresses.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__